'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = require('prosemirror-state');
var prosemirrorView = require('prosemirror-view');
var index_js = require('../keymap/index.js');
var prosemirrorModel = require('prosemirror-model');

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ProseMirror-dropcursor-bottom{position:relative}.ProseMirror-dropcursor-bottom:after{content:\"\";position:absolute;bottom:-4px;left:0;right:0;height:3px;background-color:#1c6cdc;z-index:10}.ProseMirror-dropcursor-top{position:relative}.ProseMirror-dropcursor-top:after{content:\"\";position:absolute;top:2px;left:0;right:0;height:2px;background-color:#1c6cdc;z-index:10}";
styleInject(css);

const gecko = typeof navigator !== 'undefined' && /gecko\/\d/i.test(navigator.userAgent);
const linux = typeof navigator !== 'undefined' && /linux/i.test(navigator.platform);
const pluginKey = new prosemirrorState.PluginKey('dropCursor');
function dropCursor(options) {
  let timeout = null;
  const plugin = new prosemirrorState.Plugin({
    key: pluginKey,
    state: {
      init() {
        return null;
      },

      apply(tr, prev, state) {
        // Firefox on Linux gets really confused an breaks dragging when we
        // mess with the nodes around the target node during a drag. So
        // disable this plugin there. See https://bugzilla.mozilla.org/show_bug.cgi?id=1323170
        if (gecko && linux) return null;
        const command = tr.getMeta(plugin);
        if (!command) return prev;

        if (command.type === 'set') {
          return pluginStateFor(state, command.pos, options);
        }

        return null;
      }

    },
    props: {
      handleDOMEvents: {
        dragover(view, event) {
          const active = plugin.getState(view.state);
          const pos = view.posAtCoords({
            left: event.clientX,
            top: event.clientY
          });

          if (pos) {
            let target = pos.pos;

            if (view.dragging) {
              target = dropPos(view.dragging.slice, view.state.doc.resolve(target));
            }

            if (!active || active.pos !== target) {
              dispatch(view, {
                type: 'set',
                pos: target
              });
            }
          }

          scheduleRemoval(view);
          return false;
        },

        dragend(view) {
          if (plugin.getState(view.state)) dispatch(view, {
            type: 'remove'
          });
          return false;
        },

        drop(view) {
          if (plugin.getState(view.state)) dispatch(view, {
            type: 'remove'
          });
          return false;
        },

        dragleave(view, event) {
          if (event.target === view.dom) dispatch(view, {
            type: 'remove'
          });
          return false;
        }

      },

      decorations(state) {
        const active = plugin.getState(state);
        return active && active.deco;
      }

    }
  });

  function dispatch(view, data) {
    view.dispatch(view.state.tr.setMeta(plugin, data));
  }

  function scheduleRemoval(view) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (plugin.getState(view.state)) dispatch(view, {
        type: 'remove'
      });
    }, 1000);
  }

  return plugin;
}

function style(options, side) {
  if (side === 'bottom' || side === 'top') {
    return `border-${side}: 2px solid #3789a9; margin-${side}: 2px`;
  }

  const width = options && options.width || 1;
  const color = options && options.color || 'black';
  return `border-${side}: ${width}px solid ${color}; margin-${side}: -${width}px`;
}

function pluginStateFor(state, pos, options) {
  window.__EDITOR_DROP_CURSOR__ = true;
  let $pos = state.doc.resolve(pos),
      deco;

  if (!$pos.parent.inlineContent) {
    let before, after;

    if (before = $pos.nodeBefore) {
      if (before && (before.type.name === "table_row" || before.type.name === "table")) {
        return null;
      }

      deco = prosemirrorView.Decoration.node(pos - before.nodeSize, pos, {
        nodeName: 'div',
        class: 'ProseMirror-dropcursor-bottom'
      });
    } else if (after = $pos.nodeAfter) {
      if (after && after.type.name === "table_row") {
        return null;
      }

      deco = prosemirrorView.Decoration.node(pos, pos + after.nodeSize, {
        nodeName: 'div',
        class: 'ProseMirror-dropcursor-top'
      });
    }
  }

  if (!deco) {
    const node = document.createElement('span');
    node.textContent = '\u200b';
    node.style.cssText = `${style(options, 'left')}; display: inline-block; pointer-events: none`;
    deco = prosemirrorView.Decoration.widget(pos, node);
  }

  deco = prosemirrorView.DecorationSet.create(state.doc, [deco]);
  return {
    pos,
    deco
  };
}

function dropPos(slice, $pos) {
  if (!slice || !slice.content.size) return $pos.pos;
  let content = slice.content;

  for (let i = 0; i < slice.openStart; i++) content = content.firstChild.content;

  for (let d = $pos.depth; d >= 0; d--) {
    const bias = d === $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
    const insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);

    if ($pos.node(d).canReplace(insertPos, insertPos, content)) {
      return bias === 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
  }

  return $pos.pos;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

// `$anchor` and `$head` properties both point at the cursor position.

class GapCursor extends prosemirrorState.Selection {
  // : (ResolvedPos)
  constructor($pos, dom) {
    super($pos, $pos);
    this.dom = dom;
  }

  map(doc, mapping) {
    const $pos = doc.resolve(mapping.map(this.head));
    return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirrorState.Selection.near($pos);
  }

  content() {
    return prosemirrorModel.Slice.empty;
  }

  eq(other) {
    return other instanceof GapCursor && other.head === this.head;
  }

  toJSON() {
    return {
      type: 'gapcursor',
      pos: this.head
    };
  }

  static fromJSON(doc, json) {
    return new GapCursor(doc.resolve(json.pos));
  } // eslint-disable-next-line


  getBookmark() {
    return new GapBookmark(this.anchor);
  }
  /**
   * 判断节点是否需要加光标
   * @param node
   */


  static isValidNode(node) {
    // 通过节点是否有 allowGapCursor 声明来判断是否需要光标
    return !!(node && node.type.spec.allowGapCursor);
  }
  /**
   * 判断该位置是否可以显示光标
   * @param $pos
   */


  static valid($pos) {
    // 判断 $pos 的前、后是否有需要加光标的节点
    const nodeBefore = this.getNodeBefore($pos);
    const nodeAfter = this.getNodeAfter($pos);
    return !!(nodeBefore || nodeAfter);
  }
  /**
   * 返回需要显示光标的节点信息
   * @param $pos
   * @param dir           before: 找 $pos 前的节点；after: 找 $pos 后的节点
   * @param isGreedy      如果当前 pos 没找到节点，是否在临界点继续查找
   * @return object { node: 加光标的节点, pos: 光标位置, dir: 节点在光标的哪一侧 }
   */


  static findFrom($pos, dir, isGreedy = true) {
    if (dir) {
      const res = dir === 'before' ? this.getNodeBefore($pos) : this.getNodeAfter($pos);
      return res ? {
        node: res.node,
        pos: res.pos,
        dir
      } : null;
    } // 没有指定 dir，按前、后顺序查找节点


    const before = this.getNodeBefore($pos, isGreedy);

    if (before) {
      return {
        node: before.node,
        pos: before.pos,
        dir: 'before'
      };
    }

    const after = this.getNodeAfter($pos, isGreedy);
    return after ? {
      node: after.node,
      pos: after.pos,
      dir: 'after'
    } : null;
  }

  static getNodeBefore($pos, isGreedy) {
    let nodeBefore = $pos.nodeBefore;
    let pos = $pos.pos; // 点击表格右侧时，nodeBefore 不是预期的 table，而是 table_row，只能根据 node 来判断

    const node = $pos.node();
    const isNodeTable = node.type.name === 'table';

    if (isNodeTable) {
      nodeBefore = node;
      pos += node.nodeSize + 1;
    } // 段落开头，nodeBefore 为 null，需要取上一行的节点


    if (isGreedy && !nodeBefore && $pos.depth > 0) {
      const index = $pos.index($pos.depth - 1);
      const parent = $pos.node($pos.depth - 1);
      nodeBefore = index > 0 ? parent.child(index - 1) : null;
      pos -= index > 0 ? 1 : 0;
    }

    while (nodeBefore && ['list_item', 'task_item', 'paragraph'].includes(nodeBefore.type.name)) {
      nodeBefore = nodeBefore.lastChild;
      pos -= 1;
    } // 表格右侧的 pos 不准确，部分情况下需要再微调


    if (nodeBefore && nodeBefore.type.name === 'table') {
      pos -= !isNodeTable && $pos.pos >= nodeBefore.nodeSize ? 0 : 2;
    }

    return this.isValidNode(nodeBefore) ? {
      node: nodeBefore,
      pos
    } : null;
  }

  static getNodeAfter($pos, isGreedy) {
    let nodeAfter = $pos.nodeAfter;
    let pos = $pos.pos; // 段落末尾，nodeAfter 为 null，需要取下一行的节点

    if (isGreedy && !nodeAfter && $pos.depth > 0) {
      const index = $pos.index();
      const parent = $pos.node($pos.depth - 1);
      nodeAfter = parent.childCount > index + 1 ? parent.child(index + 1) : null;
      pos += parent.childCount > index + 1 ? 1 : 0;
    }

    while (nodeAfter && ['list_item', 'task_item', 'paragraph'].includes(nodeAfter.type.name)) {
      nodeAfter = nodeAfter.firstChild;
      pos += 1;
    }

    return this.isValidNode(nodeAfter) ? {
      node: nodeAfter,
      pos
    } : null;
  }

}
GapCursor.prototype.visible = false;
prosemirrorState.Selection.jsonID('gapcursor', GapCursor);

class GapBookmark {
  constructor(pos) {
    this.pos = pos;
  }

  map(mapping) {
    return new GapBookmark(mapping.map(this.pos));
  }

  resolve(doc) {
    const $pos = doc.resolve(this.pos);
    return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirrorState.Selection.near($pos);
  }

}

var css$1 = ".ProseMirror-gapcursor{display:none;position:absolute;pointer-events:none;z-index:2}.ProseMirror-gapcursor:after{content:\"\";display:inline-block;vertical-align:baseline;height:100%;border-left:1px solid #000;-webkit-animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite;animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite}.ProseMirror-focused .ProseMirror-gapcursor{display:block}@-webkit-keyframes ProseMirror-cursor-blink{to{visibility:hidden}}@keyframes ProseMirror-cursor-blink{to{visibility:hidden}}";
styleInject(css$1);

let skipUpdate;
let findDir;
let findGreedy;
let lastAction;
let lastCursor;

function reset() {
  skipUpdate = false;
  findDir = "";
  findGreedy = false;
  lastAction = {
    type: ""
  };
  lastCursor = {
    id: 0,
    type: "",
    dir: "",
    height: 0,
    top: 0,
    left: 0
  };
} // :: () → Plugin
// Create a gap cursor plugin. When enabled, this will capture clicks
// near and arrow-key-motion past places that don't have a normally
// selectable position nearby, and create a gap cursor selection for
// them. The cursor is drawn as an element with class
// `ProseMirror-gapcursor`


const pluginKey$1 = new prosemirrorState.PluginKey("gapCursor");
function gapCursor() {
  reset();
  return new prosemirrorState.Plugin({
    key: pluginKey$1,
    props: {
      decorations: drawGapCursor,
      handleClick,
      handleDoubleClick,
      handleTripleClick: handleDoubleClick,
      handleKeyDown,
      handleDOMEvents: {
        keyup: handleKeyUp,
        mousedown: handleMouseDown,
        mouseup: handleMouseUp
      }
    },

    view() {
      return {
        update: updateCursor
      };
    }

  });
}
function setLastAction(type, attr = {}) {
  lastAction = objectSpread({
    type
  }, attr);
}
function setFindDir(dir) {
  findDir = dir;
}
function getGapCursor() {
  return lastCursor;
}

function drawGapCursor(state) {
  if (!(state.selection instanceof GapCursor)) {
    return null;
  }

  const pos = state.selection.head;
  const node = getCursorNode();
  const key = `gapCursor${lastCursor.id}`;
  return prosemirrorView.DecorationSet.create(state.doc, [prosemirrorView.Decoration.widget(pos, node, {
    key
  })]);
}

function getCursorNode() {
  const node = document.createElement("div");
  node.className = "ProseMirror-gapcursor";
  node.style.height = `${lastCursor.height}px`;
  node.style.top = `${lastCursor.top}px`;
  node.style.left = `${lastCursor.left}px`;
  return node;
}
/**
 * 将光标的处理统一放在 update 中，handleClick、handleKeyDown 只是处理一些额外情况
 * @param view
 */


function updateCursor(view) {
  const {
    state,
    dispatch
  } = view;
  const {
    selection,
    tr,
    doc
  } = state;
  const {
    $anchor,
    $head,
    anchor,
    head
  } = selection;
  const isNodeSelection = selection instanceof prosemirrorState.NodeSelection;
  const isGapCursorSelection = selection instanceof GapCursor;
  let $pos = $head;
  let isHideCursor = false; // 跳过校验时机不对的场景（如避免重复判断）

  if (skipUpdate) {
    skipUpdate = false;
    return;
  } // 避免无法从光标处开始选中内容


  if (isGapCursorSelection && lastAction.type === "mouseDown") {
    // XXX 表格拖动列宽时，不会触发 update，导致光标异常，暂时通过隐藏光标来解决
    if (lastCursor.type === "table") {
      isHideCursor = true;
    } else {
      return;
    }
  } // 允许选中节点


  if (isNodeSelection && lastAction.type !== "keyDown") {
    return;
  } // 有选区时不显示 gapCursor


  if (!isNodeSelection && anchor !== head) {
    return;
  }

  if (isNodeSelection && lastAction.type === "keyDown" && lastAction.dir === "right") {
    $pos = $anchor;
  }

  if (isGapCursorSelection) {
    setFindDir(lastCursor.dir);
  }

  const res = GapCursor.findFrom($pos, findDir, findGreedy);
  setFindDir("");
  findGreedy = false;

  if (res) {
    const dom = getResDom(view, res);
    const isUpdate = updateCursorStyle(dom, res) || isHideCursor;

    if (dom.offsetHeight === 0 && dom.classList.contains("ct-image")) {
      setTimeout(() => {
        updateCursor(view);
      }, 100);
      return;
    }

    if (isHideCursor) {
      lastCursor.id += 1;
      lastCursor.height = 0;
    }

    if (isUpdate) {
      skipUpdate = true;
      dispatch(tr.setSelection(new GapCursor(doc.resolve(res.pos), dom)));
    }
  } else {
    lastCursor.height = 0;

    if (selection instanceof GapCursor) {
      skipUpdate = true;
      dispatch(tr.setSelection(prosemirrorState.Selection.near($head)));
    }
  }
}
/**
 * 更新 cursor 的展示样式
 * @param dom
 * @param res   dir: 节点在光标的哪一侧（before、after
 */


function updateCursorStyle(dom, res) {
  if (!dom) {
    return false;
  } // 计算位置、高度信息


  const {
    dir
  } = res;
  const {
    offsetTop,
    offsetLeft
  } = getDomOffset(dom);
  let height = dom.offsetHeight;
  let top = offsetTop;
  let left = (dir === "before" ? dom.offsetWidth : 0) + offsetLeft; // 表格超出编辑宽度，需要采用 tableWrapper 的宽度来计算

  if (dir === "before" && getTagName(dom) === "table" && hasClass(dom.parentNode, "ct-table-wrapper")) {
    if (dom.offsetWidth > dom.parentNode.offsetWidth) {
      left = dom.parentNode.offsetWidth + dom.offsetLeft;
    }
  } // 微调光标位置


  if (hasClass(dom, "ct-image") && dir === "after") {
    left -= 1;
  } else if (hasClass(dom, "ct-mention") || hasClass(dom, "ct-status")) {
    left += dir === "after" ? -2 : 1;
  } // 水平线的 height、top 都不对


  if (getTagName(dom) === "hr") {
    height = 16;
    top -= 8;
  } // TODO 标题里的 status、mention 的 top 不对，跟 lineHeight、verticalAlign 相关，暂且先特殊解决


  if (hasClass(dom, "ct-mention") || hasClass(dom, "ct-status")) {
    let tagName = getTagName(dom.parentNode);

    if (tagName === "h1" || tagName === "h2") {
      if (hasClass(dom, "ct-mention")) {
        top -= tagName === "h1" ? 11 : 6;
      } else {
        top -= tagName === "h1" ? 7 : 2;
      }
    } // 表格里的也不对


    if (tagName === "p") {
      tagName = getTagName(dom.parentNode.parentNode);
    }

    if (tagName === "td" || tagName === "th") {
      top += 1;
      left += 1;
    }
  } // 添加的光标位置不同，但 pos 可能相同，通过 widget 的 key 来触发重绘


  if (lastCursor.height !== height || lastCursor.top !== top || lastCursor.left !== left) {
    const id = lastCursor.id + 1;
    const type = res.node.type.name;
    lastCursor = {
      id,
      type,
      dir,
      height,
      top,
      left
    };
    return true;
  }

  return false;
}
/**
 * 获取 dom 元素的偏移位置
 * @param dom
 */


function getDomOffset(dom) {
  let offsetTop = dom.offsetTop;
  let offsetLeft = dom.offsetLeft;
  let offsetParent = dom.offsetParent;

  while (offsetParent && window.getComputedStyle(offsetParent, null).position === "static") {
    offsetTop += offsetParent.offsetTop;
    offsetLeft += offsetParent.offsetLeft;
    offsetParent = offsetParent.offsetParent;
  }

  return {
    offsetTop,
    offsetLeft
  };
}
/**
 * 获取 dom 元素
 * @param view
 * @param _res   pos: 光标添加位置, dir: 节点在光标的哪一侧（before、after
 */


function getResDom(view, _res) {
  if (!_res) {
    return null;
  } // 若节点在光标的左侧，dom 的 pos 需重新计算


  const {
    pos,
    dir
  } = _res;
  let res;

  try {
    res = view.domAtPos(pos + (dir === "before" ? -1 : 0));
  } catch (error) {
    console.error(error);
    return;
  }

  let dom = res.node.childNodes[res.offset]; // 避免将光标 dom 作为目标进行计算

  if (hasClass(dom, "ProseMirror-gapcursor")) {
    dom = res.node.childNodes[res.offset + (dir === "before" ? -1 : 2)];
  } // 表格，取 table 为计算目标


  if (hasClass(dom, "ct-table-wrapper")) {
    dom = dom.firstChild;
  } // 部分行内元素的 dom 获取逻辑也不同


  const nodeCls = res.node.className;
  const caseArr = ["ct-note-content", "ct-collapse-content", "ct-task-li", "ct-task-li-checked"];

  if (nodeCls && /^ct-/.test(nodeCls) && !caseArr.includes(nodeCls)) {
    dom = res.node;
  } // 点击右侧的情况，根据 pos 获取的 dom 不准确，需要额外处理


  if (getTagName(res.node) === "tbody") {
    dom = res.node.parentNode;
  }

  if (getTagName(res.node) === "code") {
    dom = res.node.parentNode && res.node.parentNode.parentNode;
  } // 代码块 codeMirror 右侧的情况


  if (getTagName(dom) === "div" && hasClass(dom.parentNode, "CodeMirror")) {
    dom = dom.parentNode;
  }

  return dom;
}

function getTagName(dom) {
  return (dom && dom.tagName || "").toLowerCase();
}

function hasClass(dom, cls) {
  return dom && dom.className && dom.classList.contains(cls);
}

function handleKeyUp(view, event) {
  if (event.keyCode === 229) {
    const {
      state,
      dispatch
    } = view;
    const {
      tr,
      selection
    } = state;
    const {
      $from
    } = selection;

    if (selection instanceof GapCursor && $from.nodeAfter && $from.nodeAfter.type.name === "image") {
      const newSelection = prosemirrorState.TextSelection.create(tr.doc, $from.pos);
      tr.setSelection(newSelection);
      dispatch(tr);
      view.focus();
    }
  }

  return false;
}

function handleMouseDown() {
  setLastAction("mouseDown");
  return false;
}

function handleMouseUp() {
  setLastAction("mouseUp");
  return false;
}
/**
 * pos 不变时，update 不会触发
 * @param view
 * @param _pos
 * @param event
 */


function handleClick(view, _pos, event) {
  setLastAction("click");
  const state = view.state;
  const posInfo = view.posAtCoords({
    left: event.clientX,
    top: event.clientY
  });
  let pos = _pos;
  let $pos = state.doc.resolve(pos); // 处理文本点击

  if ($pos.nodeAfter && $pos.nodeAfter.type.name === 'paragraph') {
    view.dispatch(view.state.tr.setSelection(prosemirrorState.TextSelection.create(state.doc, pos + 1, pos + 1)));
    return true;
  } // 处理序列非内容区点击


  const $from = view.state.selection.$from;
  const parentNode = $from.node(-1);
  const afterNode = $from.nodeAfter; // 点击序列项中文本内容前时

  if (parentNode && afterNode && parentNode.type.name === "list_item" && afterNode.type.name === "text") {
    return false;
  } // 点击序列项中表格元素前时


  const listNode = $from.node(-4);
  const tableNode = $from.node(-3);
  const tableStart = $from.start(-3);

  if (listNode && tableNode && listNode.type.name === "list_item" && tableNode.type.name === "table" && pos < tableStart) {
    updateCursorStyle(view.docView.domFromPos(tableStart), {
      dir: "after",
      node: tableNode
    });
    const newSelection = new GapCursor(state.doc.resolve(tableStart - 1));
    view.dispatch(state.tr.setSelection(newSelection));
    return true;
  }

  try {
    // 处理同一段段落中文本与图片不同行时光标位置
    const nodeSelection = prosemirrorState.NodeSelection.create(state.doc, pos);

    if (nodeSelection) {
      const selNode = nodeSelection.node;

      if (selNode.type.name === "image" || selNode.type.name === "drawio") {
        const domNode = view.docView.domFromPos(pos).node;
        const imageDom = domNode.querySelector(`[src="${selNode.attrs.src}"]`);
        const imageDomRect = imageDom.getBoundingClientRect();

        if (event.x > imageDomRect.x && event.y < imageDomRect.y) {
          const newSelection = new prosemirrorState.TextSelection(state.doc.resolve(_pos));
          view.dispatch(state.tr.setSelection(newSelection));
          return false;
        }
      }
    } // eslint-disable-next-line

  } catch (error) {} // 选中节点时，不显示 cursor
  // TODO 这个判断方式可能还有点问题


  let isNodeSelected = posInfo && posInfo.pos === posInfo.inside;

  if (posInfo && posInfo.inside > -1 && posInfo.inside + 1 === posInfo.pos) {
    if ($pos.nodeBefore && $pos.nodeBefore.nodeSize === 1) {
      isNodeSelected = true;
    }
  }

  if (isNodeSelected) {
    return false;
  } // 状态宏右侧的判断需要单独处理
  // 另外还需要区分点击了两个连续宏中间的情况


  const isStatus = $pos.node().type.name === "status";
  const isStatusLeft = isStatus && posInfo.inside !== $pos.before() && pos === $pos.start();
  const isStatusRight = isStatus && posInfo.inside !== $pos.before() && pos > $pos.start();

  if (isStatusLeft) {
    pos = $pos.before();
    $pos = state.doc.resolve(pos);
  } else if (isStatusRight) {
    pos = $pos.after();
    $pos = state.doc.resolve(pos);
  } // 独占一行节点右侧跟下一节点左侧的 $pos 是一样的，因此还需要结合点击位置进行判断
  // 例如"目录"后面有一段文字，点"目录"右侧需要显示光标，但点文字左侧就不需要显示
  // 总的来说，点击编辑区域左侧，需要显示光标的的一定是 $pos 后面的节点


  const isAfter = pos === $pos.start() || getClickDir(event) === "left";
  const isBefore = pos === $pos.end() || $pos.parent.type.name === "table" && pos === $pos.start();
  const dir = (isBefore ? "before" : "") || (isAfter ? "after" : "");
  let res = GapCursor.findFrom($pos, dir);

  if (!res) {
    return false;
  } // 由于 $pos 是一样的，dir 的判断不一定准确，导致 res 有错，通过 dom 的位置进行验证


  let dom = getResDom(view, res);

  if (dom && res.dir === "before") {
    const rect = dom.getBoundingClientRect();

    if (event.pageY > rect.top + rect.height) {
      res = GapCursor.findFrom($pos, "after");
      dom = getResDom(view, res);

      if (!res || !dom) {
        view.focus();
        return false;
      }
    }
  }

  updateCursorStyle(dom, res);
  const newSelection = new GapCursor(state.doc.resolve(res.pos), dom);
  view.dispatch(state.tr.setSelection(newSelection));
  return true;
}

function handleDoubleClick(view, _pos) {
  const {
    state
  } = view;
  const {
    selection
  } = state;

  if (selection instanceof GapCursor && selection.$from.pos === _pos) {
    return true;
  }
}

const handleKeyDown = index_js.keydownHandler({
  ArrowLeft: arrow("left"),
  ArrowRight: arrow("right"),
  ArrowUp: arrow("up"),
  ArrowDown: arrow("down"),
  "Shift-ArrowLeft": arrow("left", true),
  "Shift-ArrowRight": arrow("right", true)
});
/**
 * 当光标进入节点（例如光标在节点前，按右方向键）时的偏移量
 * 对于 图片、附件 等，要跳过该节点，而对于表格、代码块，要进入该节点
 * @param view
 * @param $pos
 * @param res
 * @param dir
 */

function getEnterOffset(view, $pos, res, dir) {
  const name = res.node.type.name;
  let pos = res.node.nodeSize;

  if (name === "table") {
    pos = 3;
  } else if (name === "code") {
    pos = 2;
  }

  return (dir === "right" ? 1 : -1) * pos;
}
/**
 * 当光标脱离节点（如光标在节点后，按右方向键）时的偏移量
 * 注意相邻两个节点都需要光标的情况，此时的 pos 相同，不需要偏移量
 * @param view
 * @param $pos
 * @param res
 * @param dir
 */


function getLeaveOffset(view, $pos, res, dir) {
  let offset = 0;
  const nextNode = dir === "right" ? $pos.nodeAfter : $pos.nodeBefore;
  const isSamePos = !!(res.node.isBlock && nextNode && nextNode.type.spec.allowGapCursor);
  const ratio = isSamePos ? 0 : 1;
  offset = dir === "right" ? ratio : $pos.pos > 0 ? -1 * ratio : 0; // 如果在行末尾，还需要考虑前后元素是否为列表之类的元素

  if (!isSamePos && view.endOfTextblock(dir)) {
    let $next = view.state.doc.resolve($pos.pos + offset);

    if ($next.node().type.name === "list_item") {
      offset += dir === "right" ? 2 : -2;
      $next = view.state.doc.resolve($pos.pos + offset);
    }

    const node = dir === "right" ? $next.nodeAfter : $next.nodeBefore;
    const offsetMap = {
      bullet_list: 2,
      paragraph: 1
    };

    if (node && offsetMap[node.type.name]) {
      offset += (dir === "right" ? 1 : -1) * offsetMap[node.type.name];
    }
  }

  return offset;
}
/**
 * 判断节点是否为文档的第一个节点
 * @param $pos
 * @param node
 */


function isFirstNode($pos, node) {
  let target = node;

  for (let d = $pos.depth; d >= 0; d--) {
    if ($pos.node(d).firstChild !== target) {
      return false;
    }

    target = $pos.node(d);
  }

  return true;
}
/**
 * 判断节点是否为文档的最后一个节点
 * @param $pos
 * @param node
 */


function isLastNode($pos, node) {
  let target = node;

  for (let d = $pos.depth; d >= 0; d--) {
    if ($pos.node(d).lastChild !== target) {
      return false;
    }

    target = $pos.node(d);
  }

  return true;
}
/**
 * 光标在 gapCursor 时方向键的默认处理不对，需要跳过 gapCursor 移动到下一位置上
 * @param dir
 * @param isShift
 */


function arrow(dir, isShift) {
  return function (state, dispatch, view) {
    const {
      tr
    } = state;
    const {
      $from,
      from
    } = state.selection;
    const {
      status
    } = state.schema.nodes;
    setLastAction("keyDown", {
      dir
    });

    if (dir === "left") {
      // eslint-disable-next-line
      let textPos = from - 3;

      if (state.selection.$anchor.parentOffset === 0) {
        // 在行首需要多-1
        textPos -= 1;
      } // 第一行不处理


      if (textPos < 0) {
        return false;
      } // 处理表格下一行光标移动


      if ($from.parentOffset === 0 && !$from.nodeBefore) {
        const $pos = tr.doc.resolve(from - 2);

        if ($pos.nodeBefore && $pos.nodeBefore.type.name === "table_row") {
          const newSelection = prosemirrorState.TextSelection.create(tr.doc, from - 4);
          dispatch(tr.setSelection(newSelection));
          return true;
        }
      }

      const textNode = tr.doc.nodeAt(textPos);

      if (textNode && textNode.type.name === "text") {
        const statusPos = textPos - textNode.nodeSize;

        if (statusPos < 0) {
          return false;
        }

        const statusNode = tr.doc.nodeAt(statusPos); // 处理状态宏下一行行首光标移动

        if (statusNode && statusNode.type.name === "status") {
          const newSelection = new GapCursor(tr.doc.resolve(textPos + 2));
          dispatch(tr.setSelection(newSelection));
          return true;
        }
      } else {
        const {
          parent,
          nodeBefore
        } = $from; // 状态宏下一行行首向左移动

        if (parent && parent.type.name === status.name) {
          if (nodeBefore && nodeBefore.text === "\u200B") {
            const newSelection = prosemirrorState.TextSelection.create(tr.doc, from - 2);
            dispatch(tr.setSelection(newSelection));
            return true;
          }
        } // 状态宏从右向左移动


        if (nodeBefore && nodeBefore.type.name === status.name) {
          const newSelection = prosemirrorState.TextSelection.create(tr.doc, from - nodeBefore.nodeSize);
          dispatch(tr.setSelection(newSelection));
          return true;
        }
      }
    }

    if (dir === "right") {
      // 状态宏内光标向右移动
      if (state.selection.$cursor) {
        const $cursor = state.selection.$cursor;

        if (!$cursor.nodeAfter && $cursor.parent.type.name === status.name) {
          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1)));
          view.focus();
          return true;
        }
      } else {
        const nodeAfter = state.selection.$from.nodeAfter; // 状态宏从左到右的光标移动

        if (nodeAfter && nodeAfter.type.name === status.name) {
          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1 + nodeAfter.nodeSize)));
          view.focus();
          return true;
        }
      }
    }

    if (!(state.selection instanceof GapCursor)) {
      // 通过键盘上下键移动，会触发两次 update，一次是在原来的位置，一次是在新的位置（需要跳过第一次 update）
      // 而左右键、加 shift、在 gapCursor 上按上下键，只会触发一次 update
      skipUpdate = dir === "up" || dir === "down";
      return false;
    }

    const {
      selection,
      doc
    } = state;
    let pos = selection.head;
    const $pos = doc.resolve(pos); // TODO 上下键，浏览器的行为是会跳到视觉上的上一行位置

    if (dir === "up" || dir === "down") {
      const beforeNode = selection.$from.nodeBefore;
      const afterNode = selection.$to.nodeAfter; // 表格中状态光标上下移动

      if (beforeNode && beforeNode.type.name === "status" || afterNode && afterNode.type.name === "status") {
        const path = selection.$from.path;
        const parentNode = path[path.length - 3];
        const parent1Node = path[path.length - 6];
        const parent2Node = path[path.length - 9];
        const parent3Node = path[path.length - 12];

        if (parent2Node && parent2Node.type.name === "table_row") {
          let newPos = null;

          if (dir === "up" && parent1Node.firstChild === parentNode && parent3Node.firstChild !== parent2Node) {
            const rowIndex = parent3Node.content.content.indexOf(parent2Node);
            const cellIndex = parent2Node.content.content.indexOf(parent1Node);
            const tableContent = parent3Node.content.content;
            const rowContent = parent3Node.content.content[rowIndex - 1].content.content;
            newPos = path[path.length - 13] + 2;
            tableContent.forEach((node, i) => {
              if (i < rowIndex - 1) {
                newPos += node.nodeSize;
              }
            });
            rowContent.forEach((node, i) => {
              if (i < cellIndex) {
                newPos += node.nodeSize;
              }
            });
          } else if (dir === "down" && parent1Node.lastChild === parentNode && parent3Node.lastChild !== parent2Node) {
            const rowIndex = parent3Node.content.content.indexOf(parent2Node);
            const cellIndex = parent2Node.content.content.indexOf(parent1Node);
            const tableContent = parent3Node.content.content;
            const rowContent = parent3Node.content.content[rowIndex + 1].content.content;
            newPos = path[path.length - 13] + 2;
            tableContent.forEach((node, i) => {
              if (i <= rowIndex) {
                newPos += node.nodeSize;
              }
            });
            rowContent.forEach((node, i) => {
              if (i < cellIndex) {
                newPos += node.nodeSize;
              }
            });
          }

          if (newPos) {
            const newSelection = prosemirrorState.TextSelection.create(doc, newPos);
            dispatch(state.tr.setSelection(newSelection));
            return false;
          }
        }
      }

      if ($pos.depth) {
        pos = dir === "up" ? $pos.before() > 0 ? $pos.before() - 1 : 0 : $pos.after() + 1;
      } else {
        // TODO 待完善
        pos += dir === "up" ? pos > 0 ? -1 : 0 : 1;
      }

      if (dir === "down") {
        const docSize = doc.resolve(0).node().nodeSize;

        if (pos > docSize - 2) {
          pos = docSize - 2;
        }
      }

      const newSelection = !isShift ? prosemirrorState.TextSelection.create(doc, pos) : prosemirrorState.TextSelection.create(doc, selection.anchor, pos);
      dispatch(state.tr.setSelection(newSelection));
      return true;
    }

    const curRes = GapCursor.findFrom($pos, lastCursor.dir);

    if (!curRes) {
      return false;
    } // 边界处理


    const isDocBegin = curRes.dir === "after" && isFirstNode($pos, curRes.node);
    const isDocEnd = curRes.dir === "before" && isLastNode($pos, curRes.node);

    if (isDocBegin && dir === "left" || isDocEnd && dir === "right") {
      return true;
    } // 左右键，移动到下一位置上


    if (curRes.dir === "before" && dir === "right" || curRes.dir === "after" && dir === "left") {
      pos += getLeaveOffset(view, $pos, curRes, dir);
      setFindDir(dir === "right" ? "after" : "before");
    } else {
      pos += getEnterOffset(view, $pos, curRes, dir);
      setFindDir(dir === "right" ? "before" : "after");
    }

    const newSelection = !isShift ? prosemirrorState.TextSelection.create(state.doc, pos) : prosemirrorState.TextSelection.create(doc, selection.anchor, pos);
    dispatch(tr.setSelection(newSelection));
    return true;
  };
}
/**
 * 判断点击的位置，位于编辑区域中，还是位于左右侧
 * @param event
 * @returns {string}
 */


function getClickDir(event) {
  const pmNode = document.querySelector(".ProseMirror");
  const pmNodeStyle = window.getComputedStyle(pmNode, null);
  const paddingLeft = parseInt(pmNodeStyle.paddingLeft, 10);
  const paddingRight = parseInt(pmNodeStyle.paddingRight, 10);
  const {
    left
  } = pmNode.getBoundingClientRect();

  if (event.clientX <= left + paddingLeft) {
    return "left";
  }

  return event.pageX >= pmNode.offsetWidth - paddingRight ? "right" : "inner";
}

class CursorModule {
  constructor() {
    this.name = 'cursor';
    this.plugins = [dropCursor(), gapCursor()];
  }

}
CursorModule.moduleName = 'cursor';

exports.CursorModule = CursorModule;
exports.GapCursor = GapCursor;
exports.getGapCursor = getGapCursor;
exports.setLastAction = setLastAction;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/cursor/index.js